export default import.meta.ROLLDOWN_FILE_URL_BYIsBA9PcRyD0IoLR4zNdg